// Brand IDs
const PHARMA_BRAND_ID = 135
const HEALTHTECH_BRAND_ID = 134
const REPORTS_BRAND_ID = 136
const EVENTS_BRAND_ID = 141
const COMMUNICATIONS_BRAND_ID = 139

// Campaign IDs
const PHARMA_CAMPAIGN_ID = 135
const HEALTHTECH_CAMPAIGN_ID = 134
const REPORTS_CAMPAIGN_ID = 136
const EVENTS_CAMPAIGN_ID = 141
const COMMUNICATIONS_CAMPAIGN_ID = 139

// Site ID
const SITE_ID = 0

// Descriptions
const PHARMA_DESCRIPTION =
  'Important updates regarding FirstWord Pharma, including new features and exclusive offer'
const HEALTHTECH_DESCRIPTION =
  'Important updates regarding FirstWord HealthTech, including new features and exclusive offers'
const REPORTS_DESCRIPTION =
  'The latest industry intelligence available through FirstWord Reports'
const EVENTS_DESCRIPTION =
  'Information and updates on our upcoming industry events'
const COMMUNICATIONS_DESCRIPTION = 'Communications from our industry partners'

export const FIRST_WORD_ONGAGE_UNSUBSCRIBE = [
  {
    label: PHARMA_DESCRIPTION,
    campaignId: PHARMA_CAMPAIGN_ID,
    brandId: PHARMA_BRAND_ID,
    siteId: SITE_ID
  },
  {
    label: HEALTHTECH_DESCRIPTION,
    campaignId: HEALTHTECH_CAMPAIGN_ID,
    brandId: HEALTHTECH_BRAND_ID,
    siteId: SITE_ID
  },
  {
    label: REPORTS_DESCRIPTION,
    campaignId: REPORTS_CAMPAIGN_ID,
    brandId: REPORTS_BRAND_ID,
    siteId: SITE_ID
  },
  {
    label: EVENTS_DESCRIPTION,
    campaignId: EVENTS_CAMPAIGN_ID,
    brandId: EVENTS_BRAND_ID,
    siteId: SITE_ID
  },
  {
    label: COMMUNICATIONS_DESCRIPTION,
    campaignId: COMMUNICATIONS_CAMPAIGN_ID,
    brandId: COMMUNICATIONS_BRAND_ID,
    siteId: SITE_ID
  }
]
